import { render, staticRenderFns } from "./TableHistoryContainer.vue?vue&type=template&id=4ece0cce&"
import script from "./TableHistoryContainer.vue?vue&type=script&lang=ts&"
export * from "./TableHistoryContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports